// extracted by mini-css-extract-plugin
export default {"canvas":"_3DModel_canvas__S4TS7"};